import React from 'react';
import { Helmet } from 'react-helmet-async';
import { META_TAGS } from '../config/metaTags';

const SEO = ({ page, customMeta = {}, metaTags: serverMetaTags = {} }) => {
  // Use server meta tags if available, otherwise fall back to static meta tags
  const metaTags = serverMetaTags || META_TAGS[page] || META_TAGS.home || {};
  
  const {
    title = metaTags.title || '',
    description = metaTags.description || '',
    keywords = metaTags.keywords || '',
    ogTitle = metaTags.ogTitle || '',
    ogDescription = metaTags.ogDescription || '',
    ogImage = metaTags.ogImage || '',
    canonical = metaTags.canonical || '',
  } = { ...metaTags, ...customMeta };

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      
      {/* Primary Meta Tags */}
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={customMeta ? 'article' : 'website'} />
      <meta property="og:url" content={canonical || (typeof window !== 'undefined' ? window.location.href : '')} />
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonical || (typeof window !== 'undefined' ? window.location.href : '')} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      {ogImage && <meta property="twitter:image" content={ogImage} />}
      
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="author" content="Shape Shifting Mastery" />
      <meta name="revisit-after" content="7 days" />
    </Helmet>
  );
};

export default SEO; 